import type { BrandConfigDetail } from '@/pleased-sdk/PleasedApi/models.pleased';

import { SystemOptionType } from '../message/enum';
import { createCategoryListMessage } from '../message/lib';
import type { SystemListMessage } from '../message/types';

export type BuildCategoryListMessageOptions = {
  id?: string;
  history?: SystemListMessage['history'];
};

export const buildCategoryListMessageFromBrandConfig = (
  brandConfig: BrandConfigDetail,
  options?: BuildCategoryListMessageOptions
) =>
  createCategoryListMessage({
    message: brandConfig.brandConfig.showWelcomeMessage ? brandConfig.brandConfig.welcomeMessage : '',
    options: brandConfig.categories.map((category) => ({ ...category, kind: SystemOptionType.CATEGORY })),
    id: options?.id ?? 'category-base',
    ...(options?.history ? { history: options.history } : {}),
  });
